import React, { useState } from 'react';
import UserLayout from './UserLayout';
import ContactForm from '../ContactForm';
import PageHeader from '../shared/PageHeader';
import Card from '../shared/Card';

const UserContact = () => {
  // Bumped by the form's post-send onClose to remount a fresh, empty form.
  const [formKey, setFormKey] = useState(0);

  return (
    <UserLayout>
      <div className="max-w-2xl space-y-6">
        <PageHeader
          title="Contact Us"
          description="Send a message to our sales team, or use the live chat button in the bottom-right corner."
        />
        <Card padding="none" className="overflow-hidden">
          <ContactForm
            key={formKey}
            inline
            isOpen
            onClose={() => setFormKey((k) => k + 1)}
          />
        </Card>
      </div>
    </UserLayout>
  );
};

export default UserContact;
